export default __webpack_public_path__ + "static/media/icon-css.affa707d.svg";